import { baseApi } from '@/store/api/base.api';

export const impressiveApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getImpressives: builder.query<any, string>({
			query: (query) => ({
				url: `/impressives?${query}`,
				method: 'GET',
			}),
		}),
	}),
	overrideExisting: true,
});

export const { useGetImpressivesQuery } = impressiveApi;
